import phone from "../../assest/contact/phone.png";
import mail from "../../assest/contact/email.png";
import location from "../../assest/contact/location.png";

const ContactInfo = () => {
  return (
    <div className="contact-information">
      {/* Contact Information Section */}
      <div className="contact-info">
        <h2>Contact Information</h2>
        <p>We’ve grown up with the internet revolution, and we</p>
        <p>know how to deliver on its promises.</p>
        {/* Contact Details */}
        <div className="contact-box">
          <div className="contact-icon">
            <img src={phone} alt="icon" />
          </div>
          <div className="contact-details">
            <h5>Contact Us</h5>
            <p>(124)-555-6565</p>
          </div>
        </div>
        <div className="contact-box">
          <div className="contact-icon">
            <img src={mail} alt="icon" />
          </div>
          <div className="contact-details">
            <h5>Send Us a Mail</h5>
            <p>admin@techxen.org</p>
          </div>
        </div>
        <div className="contact-box">
          <div className="contact-icon">
            <img src={location} alt="icon" />
          </div>
          <div className="contact-details">
            <h5>Office Location</h5>
            <p>
              73 Bridge St Brooklyn Arkansas
              <br />
              85032 United States, NY 10018
            </p>
          </div>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="contact-form">
        <form>
          <div className="input-group">
            <input
              type="text"
              placeholder="Name"
              className="contact-form-input"
              name="first-name"
            />
            <input
              type="email"
              placeholder="Email"
              className="contact-form-input"
              name="email"
            />
            <input
              type="text"
              placeholder="Phone"
              className="contact-form-input"
              name="subject"
            />
            <input
              type="text"
              placeholder="Subject"
              className="contact-form-input"
              name="subject"
            />
            <textarea
              cols="30"
              rows="5"
              className="contact-form-input"
              placeholder="Message"
              name="message"
              style={{ resize: "none", height: "135px" }}
            ></textarea>
          </div>

          <div>
            <button type="submit" className="submit-button">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactInfo;
